import About from "./Components/About";
import Banner from "./Components/Banner";
import { ContactUs } from "./Components/Contact";
import Header from "./Components/Header";
import Skills from "./Components/Skills";
import Blogs from "./Components/Blogs";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Projects from "./Components/Projects";
import Footer from "./Components/Footer";
import AnimatedCursor from "react-animated-cursor"

// import AOS from 'aos';
// import 'aos/dist/aos.css';  
// AOS.init();

function App() {
  return (
    <div>
      <Header></Header>
      <Banner></Banner>
      <About></About>
      <Skills></Skills>
      <Projects></Projects>
      <Blogs></Blogs>
      <ContactUs></ContactUs>
      <Footer />
      <AnimatedCursor
        color='23, 168, 117'
        innerSize={16}
      />
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default App;
